// extracted by mini-css-extract-plugin
module.exports = {"wrap":"cm-z","subtitle":"dm-z","contentWrap":"em-z","imgWrap":"fm-z","heading":"gm-z","copy":"hm-z"};